import { render } from "./Icons.vue?vue&type=template&id=fa08342c&scoped=true"
import script from "./Icons.vue?vue&type=script&lang=js"
export * from "./Icons.vue?vue&type=script&lang=js"

import "./Icons.vue?vue&type=style&index=0&id=fa08342c&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa08342c"]])

export default __exports__